import { render, staticRenderFns } from "./PersonalCompanyActivate.vue?vue&type=template&id=19f02a60&"
import script from "./PersonalCompanyActivate.vue?vue&type=script&lang=js&"
export * from "./PersonalCompanyActivate.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCompanyActivate.vue?vue&type=style&index=0&id=19f02a60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports